import {FieldDefinitionGraphQL} from '../processFlowchartConfigEditorConstants';

function buildFieldTypeIndex(
  fieldDefinitions: Array<FieldDefinitionGraphQL> | null | undefined
): Map<string, string> {
  const index = new Map<string, string>();
  for (const fieldDef of fieldDefinitions ?? []) {
    index.set(fieldDef.fieldClientIdentifier, fieldDef.fieldDefinition.__typename);
  }
  return index;
}

export function getChangedFieldTypeClientIds(
  oldInputDefs: Array<FieldDefinitionGraphQL> | null,
  newInputDefs: Array<FieldDefinitionGraphQL> | null,
  oldOutputDefs: Array<FieldDefinitionGraphQL> | null,
  newOutputDefs: Array<FieldDefinitionGraphQL> | null
): Set<string> {
  const changed = new Set<string>();
  const oldInputIndex = buildFieldTypeIndex(oldInputDefs);
  const newInputIndex = buildFieldTypeIndex(newInputDefs);
  const oldOutputIndex = buildFieldTypeIndex(oldOutputDefs);
  const newOutputIndex = buildFieldTypeIndex(newOutputDefs);

  for (const [clientId, oldType] of oldInputIndex) {
    const newType = newInputIndex.get(clientId);
    if (newType != null && newType !== oldType) {
      changed.add(clientId);
    }
  }
  for (const [clientId, oldType] of oldOutputIndex) {
    const newType = newOutputIndex.get(clientId);
    if (newType != null && newType !== oldType) {
      changed.add(clientId);
    }
  }
  return changed;
}
